import axios from 'axios';

// Use relative /api path when on custom domain (not preview)
const backendUrl = process.env.REACT_APP_BACKEND_URL || '';
const isPreviewDomain = window.location.hostname.includes('preview.emergentagent.com');
const baseURL = isPreviewDomain ? `${backendUrl}/api` : '/api';

const api = axios.create({
  baseURL,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' }
});

// Public routes that should NEVER be auto-redirected to /login on a background 401.
// Otherwise an unrelated background fetch that 401s can yank an anonymous visitor
// off /register, /forgot-password, etc.
const PUBLIC_ROUTES = ['/login', '/register', '/forgot-password', '/reset-password'];

api.interceptors.response.use(
  response => response,
  async error => {
    if (error.response?.status === 401 && !error.config._retry && !error.config.url?.includes('/auth/')) {
      error.config._retry = true;
      try {
        await api.post('/auth/refresh');
        return api(error.config);
      } catch {
        // Only redirect if the user is on a protected page. Public pages
        // (login/register/etc.) must never be knocked off by a stray 401.
        const path = window.location.pathname || '';
        const onPublicRoute = PUBLIC_ROUTES.some(p => path === p || path.startsWith(p + '/'));
        if (!onPublicRoute) {
          window.location.href = '/login';
        }
      }
    }
    return Promise.reject(error);
  }
);

export function formatError(detail) {
  if (detail == null) return 'Something went wrong.';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map(e => e?.msg || JSON.stringify(e)).join(' ');
  if (detail?.msg) return detail.msg;
  return String(detail);
}

export default api;
